import Http from './http'

const AUTH_TOKEN_KEY = 'authToken'

export default function configAuth (token) {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
  } else {
    token = localStorage.getItem(AUTH_TOKEN_KEY)
  }

  Http.defaults.headers.common.Authorization = `Token ${token}`
}

export function configAuthFromRouter (router) {
  const currentRoute = router.currentRoute
  configAuth(currentRoute.query.token)
  if (Object.keys(currentRoute.query).length) {
    router.replace({ path: currentRoute.path, params: currentRoute.params })
  }
}
